/**
 * Where the SharePoint tree is pointed. It lives here, in the shared browsing layer, because every
 * surface that walks the tree carries one — the Artifacts section's tab keeps it in the URL, the
 * composer's dialog keeps it in component state — and one shape is what stops the two from drifting.
 */
export interface SharePointTreePosition {
  siteId: string | null;
  driveId: string | null;
  /** The open folder, or null for the library's root. */
  folderId: string | null;
  /** The file the link points at, so the surface can bring it to the user's attention. */
  itemId: string | null;
}

/** The tree's root: no site, no library, no folder, nothing pointed at. */
export const SHAREPOINT_TREE_ROOT: SharePointTreePosition = {
  siteId: null,
  driveId: null,
  folderId: null,
  itemId: null,
};
